// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__21PlC","Buttons":"Controls_Buttons__2G2H5"};